import React, { useMemo } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";

// configure marked once
marked.setOptions({
  gfm: true,
  breaks: true,
  tables: true,
  smartLists: true,
});

function normalizeMarkdown(input = "") {
  if (!input) return "";

  // 1. normalize line endings
  // let s = input.replace(/\r\n/g, "\n").replace(/\r/g, "\n");

  // 2. Convert backslash-line-continuations (`\` at EOL) to two spaces + newline
  //    Markdown uses two trailing spaces + newline to mean <br>.
  // s = s.replace(/\\\n/g, "  \n");

  // 3. Collapse 3+ consecutive newlines into exactly two (avoid creating empty paragraphs)
  let s = input.replace(/\n{3,}/g, "\n");

  // 4. Trim leading/trailing blank lines
  // s = s.replace(/^\s*\n+/, "").replace(/\n+\s*$/, "");

  return s;
}

export default function MarkdownRenderer({ markdown = "" }) {
  // useMemo so we only re-run processing when markdown changes
  const html = useMemo(() => {
    const cleaned = normalizeMarkdown(markdown);
    const dirtyHtml = marked.parse(cleaned || "");
    const safe = DOMPurify.sanitize(dirtyHtml, { USE_PROFILES: { html: true } });
    return safe;
  }, [markdown]);

  return (
    <div
      dir="auto"
      className="markdown-content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}